import { Layout } from "antd";
import React from "react";
const { Sider, Content } = Layout;
type SplitterProps = {
  /** Orientation of the splitter */
  orientation?: "horizontal" | "vertical";
  /** Spacing between panels */
  gutter?: number;
  /** Left or Top Panel */
  panel1: React.ReactNode;
  /** Right or Bottom Panel */
  panel2: React.ReactNode;
  /** Width of the first panel (for horizontal split) */
  panel1Size?: string | number;
  /** Whether the splitter is resizable */
  resizable?: boolean;
};
const Splitter: React.FC<SplitterProps> = ({
  orientation = "horizontal",
  gutter = 8,
  panel1,
  panel2,
  panel1Size = "50%",
  resizable = false,
}) => {
  const isVertical = orientation === "vertical";
  return (
    <Layout
      style={{
        display: "flex",
        flexDirection: isVertical ? "column" : "row",
        gap: gutter,
        height: "100%",
        width: "100%",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Sider
        style={{
          flex: `0 0 ${panel1Size}`,
          background: "#f0f2f5",
          overflow: "auto",
        }}
        width={isVertical ? undefined : panel1Size} // Handle horizontal layout width
      >
        {panel1}
      </Sider>
      <Content
        style={{
          flex: 1,
          background: "#ffffff",
          overflow: "auto",
        }}
      >
        {panel2}
      </Content>
    </Layout>
  );
};
export default Splitter;
